import _get from "lodash.get";
export var ISO_639_1;
(function (ISO_639_1) {
    ISO_639_1["EN"] = "en";
    ISO_639_1["RU"] = "ru";
    ISO_639_1["FR"] = "fr";
    ISO_639_1["TR"] = "tr";
})(ISO_639_1 || (ISO_639_1 = {}));
var ISO_DEFAULT = ISO_639_1.EN;
var i18nHandler = /** @class */ (function () {
    function i18nHandler() {
    }
    i18nHandler.getInstance = function () {
        if (!this._instance) {
            this._instance = new i18nHandler();
        }
        return this._instance;
    };
    i18nHandler.prototype.load_i18n = function (iso, data_i18n) {
        console.log("[splash] '".concat(iso, "' is loaded"));
        this.iso = iso;
        this.data_i18n = data_i18n;
    };
    i18nHandler.prototype.load = function (iso) {
        if (iso === void 0) { iso = ISO_DEFAULT; }
        var _iso = iso;
        var data_i18n;
        try {
            data_i18n = require("./data/i18n/".concat(iso, ".json"));
        }
        catch (err) {
            _iso = ISO_DEFAULT;
            data_i18n = require("./data/i18n/en.json");
        }
        finally {
            this.load_i18n(_iso, data_i18n);
        }
    };
    i18nHandler.prototype.get = function (key) {
        return _get(this.data_i18n, key, "");
    };
    return i18nHandler;
}());
export default i18nHandler;
